import { useState } from 'react'
import type { UIEvent } from 'react'

const IS_SCROLL_AREA_HEIGHT = 300

export function useScrollToBottom() {
  const [isScrollBottom, setIsScrollBottom] = useState<boolean>(false)

  const checkScrollToBottom = ({ currentTarget: { clientHeight, scrollHeight, scrollTop } }: UIEvent<HTMLElement>) => {
    if (isScrollBottom) {
      return
    }

    if (scrollTop + clientHeight + IS_SCROLL_AREA_HEIGHT >= scrollHeight) {
      setIsScrollBottom(true)
    }
  }

  const checkDidMountScrollHeight = (scrollHeight: number, clientHeight: number) => {
    if (scrollHeight - IS_SCROLL_AREA_HEIGHT <= clientHeight) {
      setIsScrollBottom(true)
    }
  }

  return { isScrollBottom, setIsScrollBottom, checkScrollToBottom, checkDidMountScrollHeight }
}
